import base from "./base/index"; // 接口域名列表
import axios from "../utils/http"; // 导入http中创建的axios实例
import utils from "../utils";
/**
 * 枚举类
 */
const enumClass = {

  /**
   * 创建
   */
  createEnumClass (companyId, name, displayName, parentId) {
    return axios.post(base.enumClass.createEnumClass, utils.postParamsArrayToJsonString({ companyId, name, displayName, parentId }))
  },
  /**
   * 修改
   */
  modifyEnumClass (id, name, displayName, parentId) {
    return axios.post(base.enumClass.modifyEnumClass, utils.postParamsArrayToJsonString({ id, name, displayName, parentId }))
  },
  /**
   * 删除
   */
  deleteEnumClass (id) {
    return axios.post(base.enumClass.deleteEnumClass, utils.postParamsArrayToJsonString({ id }))
  },
  /**
   * 查询
   */
  getSubEnumClasses (id, onlyDirect, companyId) {
    return axios.post(base.enumClass.getSubEnumClasses, utils.postParamsArrayToJsonString({ id, onlyDirect, companyId }))
  },
  /**
   * 查询
   */
  getSubEnumClasses2 (name, onlyDirect, companyId) {
    return axios.post(base.enumClass.getSubEnumClasses2, utils.postParamsArrayToJsonString({ name, onlyDirect, companyId }))
  },
  /**
   * 从枚举类中查询测量点getMeasuresFromEnumClasses
   */
  getMeasuresFromEnumClasses (classes, companyId) {
    return axios.post(base.enumClass.getMeasuresFromEnumClasses, utils.postParamsArrayToJsonString({ classes, companyId }))
  },
  /**
   * 从枚举类中查询测量点getMeasuresFromEnumClasses2
   */
  getMeasuresFromEnumClasses2 (classes, companyId) {
    return axios.post(base.enumClass.getMeasuresFromEnumClasses2, utils.postParamsArrayToJsonString({ classes, companyId }))
  },
  /**
   * 查询计量点分类信息
   */
  getEnumClassesOfMeasures (measuresId) {
    return axios.post(base.enumClass.getEnumClassesOfMeasures, utils.postParamsArrayToJsonString({ measuresId }))
  },
}

export default enumClass